import React, { useEffect, useState } from "react";
import CreateAddons from "./CreateGroupAddons";
import { BASE_URL } from "../../../redux/services/apiPath";
import axios from "axios";
import authHeader from "../../../redux/services/authHeader";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import { MdEdit } from "react-icons/md";
import CreateGroupAddons from "./CreateGroupAddons";

function GroupAddons() {
  const [show, setShow] = useState(false);
  const [data, setValue] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [currentItems, setList] = useState([]);
  const [groupAddons, setGroupAddOnList] = useState([]);
  const GetList = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const res = await axios.post(
      BASE_URL + `addon/getAllAddon?page=${page}`,
      { vendorId },
      authHeader()
    );

    if (res.data?.status == "success") {
      setList(res?.data?.data);
    } else {
      toast.error("Something Went Wrong");
    }
  };

  const GetGroupAddOns = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const res = await axios.post(
      BASE_URL + `addon/getAllAddonGroup`,
      { vendorId },
      authHeader()
    );

    if (res.data?.status == "success") {
      setGroupAddOnList(res?.data?.data);
      setTotalPages(res?.data?.totalPage);
    } else {
      toast.error("Something Went Wrong");
    }
  };

  useEffect(() => {
    GetGroupAddOns();
  }, [page]);

  useEffect(() => {
    GetList();
  }, []);

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };
  return (
    <div className="ms-content-wrapper">
      <div className="support-sect">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary mb-3"
                onClick={() => setShow(true)}
              >
                Create Addons
              </button>
            </div>
          </div>
          <div className="col-md-12">
            <table className="contact-ablr mt-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Addons</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className="">
                {groupAddons?.length > 0 &&
                  groupAddons?.map((val, i) => (
                    <tr key={val?._id}>
                      <td>{val?.name}</td>
                      <td>{val?.addonList?.map((a) => a?.name).join(", ")}</td>

                      <td>{val?.isActive == true ? "Active" : "Inactive"}</td>
                      <td
                        onClick={() => {
                          setShow(true);
                          setValue(val);
                        }}
                        className="cursor-pointer"
                      >
                        <MdEdit />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-md-12 mt-2 d-flex justify-content-end">
          {currentItems?.length && (
            <ReactPaginate
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={totalPages}
              previousLabel="<"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          )}
        </div>
      </div>

      <CreateGroupAddons
        show={show}
        onHide={() => {
          setShow(false);
          setValue("");
          GetList();
        }}
        currentItems={currentItems}
        data={data}
      />
    </div>
  );
}

export default GroupAddons;
